@if (isVisible === true) {
    <div @myInsertRemoveTrigger>
      <ng-content></ng-content>
    </div>
  }
